(function(angular, module) {var DateParseDirective;

DateParseDirective = function(moment) {
  'ngInject';
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      var format;
      format = attrs.dateParse || "LL";
      ngModel.$parsers.push(function(value) {
        if ((value == null) || value === "") {
          return value;
        }
        return moment(new Date(value));
      });
      ngModel.$formatters.push(function(value) {
        if (moment.isMoment(value)) {
          return value.format(format);
        } else {
          return value;
        }
      });
      return ngModel.$validators.date = function(modelValue, viewValue) {
        if ((modelValue == null) || modelValue === "") {
          return true;
        }
        return moment.isMoment(modelValue) && modelValue.isValid();
      };
    }
  };
};

module.directive('dateParse', DateParseDirective);
})(angular, angular.module("dyb.util.dates"));